module.exports = __webpack_public_path__ + "img/tray.c84d7f89.png";